import React, { Component } from 'react';
import { Icon } from 'rmwc/Icon';

/**
 * This HOC can take another component such as Button or CardAction and an
 * object load. The load object has only 1 required key: `isLoading`. While
 * isLoading is true, the component will display the LOC with a spinning
 * icon and a "Loading" message. Both the default icon and the message can
 * be overridden with `customWaitMessage` and `customSpinIcon`
 */

export function withLoading(WrappedComponent) {
  return class extends Component {
    constructor(props) {
      super(props);
    }

    render() {
      if (this.props.load.isLoading) {
        return (
          <WrappedComponent {...this.props} disabled>
            <Icon
              className="icon-spin"
              style={{
                verticalAlign: 'middle',
                fontSize: '18px',
                marginBottom: '3px',
                marginRight: '5px',
              }}
            >
              {this.props.load.customSpinIcon || 'refresh'}
            </Icon>
            {this.props.load.customWaitMessage || 'Loading'}
          </WrappedComponent>
        );
      } else {
        return <WrappedComponent {...this.props}>{this.props.children}</WrappedComponent>;
      }
    }
  };
}
